(() => {
  if (window.MOTColourSwatchInfoLoaded) return;
  window.MOTColourSwatchInfoLoaded = true;

  document.addEventListener('click', async (event) => {
    const opener = event.target.closest('[data-mot-colour-info-open]');
    if (opener) {
      event.preventDefault();
      document.getElementById(opener.dataset.motColourInfoOpen)?.showModal();
      return;
    }

    const closer = event.target.closest('[data-mot-colour-info-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }

    const modal = event.target.closest('[data-mot-colour-info-modal]');
    if (modal && event.target === modal) {
      modal.close();
      return;
    }

    const addButton = event.target.closest('[data-mot-colour-swatch-add]');
    if (!addButton || addButton.disabled) return;

    const dialog = addButton.closest('dialog');
    const label = addButton.querySelector('[data-mot-colour-swatch-label]');
    const status = dialog?.querySelector('[data-mot-colour-swatch-status]');
    addButton.disabled = true;
    if (label) label.textContent = 'Adding…';

    // Remove this overlay immediately so it never sits over the cart drawer
    // while Shopify or UpCart completes the add request.
    dialog?.close();

    const formData = new FormData();
    formData.append('id', addButton.dataset.variantId);
    formData.append('quantity', '1');
    formData.append('sections', 'cart-items,cart-footer,cart-item-count');
    formData.append('sections_url', window.location.pathname);

    try {
      const response = await fetch(window.theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: formData,
      });
      const responseText = await response.text();
      let data = {};
      try { data = responseText ? JSON.parse(responseText) : {}; } catch (_) {}
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add item');

      if (label) label.textContent = 'Added';
      if (status) status.textContent = 'Colour Swatch Set added to your cart.';
      try {
        document.body.dispatchEvent(new CustomEvent('baseline:cart:afteradditem', {
          bubbles: true, detail: { response: data, sourceId: 'mot-colour-swatch-info' },
        }));
      } catch (_) {}
      window.setTimeout(() => { if (label) label.textContent = 'Add to cart'; }, 1800);
    } catch (error) {
      if (label) label.textContent = 'Try again';
      if (status) status.textContent = error.message;
      dialog?.showModal();
    } finally {
      addButton.disabled = false;
    }
  });
})();
